import dataLayerHelper from '../helpers/dataLayer';
import debounce from '../helpers/debounce';

const $cart = $('.js-cart');

const ROW_SELECTOR = '.js-cart-item';
const ROW_QUANTITY_SELECTOR = '.js-cart-item-quantity';
const ROW_DELETE_SELECTOR = '.js-cart-item-delete';

const cart = {
  initialize() {
    this.fetchCartXhr = null;

    this.debounceUpdateQuantity = debounce((id, quantity) => {
      this.updateQuantity(id, quantity).then(() => {
        this.recalculateTotals();
      });
    }, 300);

    if ($cart.length) {
      this.url = $cart.data('cart-url');

      this.recalculateTotals();
      this.createEvents();
    }
  },

  /**
   * Hook up all events for the cart
   * @return {void}
   */
  createEvents() {
    $cart.on('change', ROW_QUANTITY_SELECTOR, (e) => {
      const row = e.currentTarget.closest(ROW_SELECTOR);

      this.debounceUpdateQuantity(row.dataset.id, e.currentTarget.value);
    });

    $cart.on('recalculate', () => {
      this.recalculateTotals();
    });

    $cart.on('click', ROW_DELETE_SELECTOR, (e) => {
      const row = e.currentTarget.closest(ROW_SELECTOR);

      this.removeRow(row);

      this.updateQuantity(row.dataset.id, 0)
        .then(() => {
          this.recalculateTotals();
        });
    });
  },

  /**
   * Calculate the cart total and output
   * @return {void}
   */
  recalculateTotals() {
    // Retrieve the cart page HTML parts, for example: { 'cart-summary': '<div>...</div>' }
    this.fetchCart(({ parts }) => {
      // Loop over every part, find the destination element and update the HTML
      Object.keys(parts).forEach((partKey) => {
        const destination = document.querySelector(`[data-ajax-sync="${partKey}"]`);

        if (destination) {
          destination.innerHTML = parts[partKey];
        }
      });
    });
  },

  /**
   * Remove the row from the DOM
   * @param {HTMLDivElement} row jQuery element of the row
   * @return {Promise}
   */
  removeRow(row) {
    row.remove();

    const quantity = parseInt(row.querySelector(ROW_QUANTITY_SELECTOR).value, 10);

    if (typeof row.dataset.gtmProduct !== 'undefined') {
      this.gtmRemove(JSON.parse(row.dataset.gtmProduct), quantity);
    }
  },

  /**
   * Add products to GTM
   * @param {Object} data GTM object
   * @param {Number} quantityIncrement Amount to increment the product
   * @return {void}
   */
  gtmAdd(data, quantityIncrement) {
    data.quantity = quantityIncrement;
    dataLayerHelper.addProduct(data);
  },

  /**
   * Remove products from GTM
   * @param {Object} data GTM object
   * @param {Number} quantityIncrement Amount to decrement the product
   * @return {void}
   */
  gtmRemove(data, quantityIncrement) {
    data.quantity = Math.abs(quantityIncrement);
    dataLayerHelper.removeProduct(data);
  },

  /**
   * Call API with cart changes
   * @param {Number} id
   * @param {Number} quantity
   * @return {void}
   */
  updateQuantity(id, quantity) {
    return $.ajax({
      url: `${window.app.api.cartChange}/${id}`,
      type: 'POST',
      data: {
        quantity,
        _method: 'put',
      },
    });
  },

  fetchCart(cb) {
    // Cancel running requests
    if (this.fetchCartXhr) {
      this.fetchCartXhr.abort();
    }

    this.fetchCartXhr = $.ajax({
      url: this.url,
      success: (res) => {
        this.fetchCartXhr = null;
        cb(this.cartHtmlToData(res));
      },
      error: () => {
        this.fetchCartXhr = null;
      },
    });
  },

  cartHtmlToData(res) {
    // Transform HTML string to DOM object
    const doc = (new DOMParser()).parseFromString(res, 'text/html');

    // Find all elements with data-ajax-sync attribute
    const summary = Array.prototype.slice.call(doc.querySelectorAll('[data-ajax-sync]'));

    const parts = {};

    summary.forEach((el) => {
      parts[el.getAttribute('data-ajax-sync')] = el.innerHTML;
    });

    return {
      parts,
    };
  },
};

export default cart;
